import { Component, OnInit, SecurityContext } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { CommonServiceService } from '../services/common-service.service';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {

  constructor(
    private service: CommonServiceService, private snackBar: MatSnackBar,
    private router: Router, private sanitizer: DomSanitizer
  ) { }
  glossaryData: any = [];
  resourceCenter: any = [];
  searchedValue: any = '';
  searchData: any = [];
  pageHeading: any = null;
  isLoadMore = false;
  totalDataCount = 0;
  public limit = 10;
  public skip = 0;
  public page = 1;
  orderSorting = '';
  tableHeading: any = [
    {
      thead: 'Term',
      key: 'term'
    },
    {
      thead: 'Definition',
      key: 'definition'
    },
  ];
  sortSelection = '';
  selectedColumn: any;

glossaryHeader = [{
  term : 'Term',
  definition : 'Definition'
}];

  ngOnInit(): void {
    this.getresourceCenterData();
    this.resourcePageHeading();
  }

  openSnackBar(data: string[], duration: number): void {
    this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
  }

getGlossaryData(page: any, searchString = '', sortingOrder: string= '', columnName: string= ''): void {
  this.service.glossaryData(page, searchString, sortingOrder, columnName).subscribe((res) => {
    if (res.success){
      this.glossaryData = res.data;
      this.totalDataCount = res.total;
      this.searchData = [...this.glossaryData];
    }
  });

}

getresourceCenterData(): void {
  this.service.resourceCenterData().subscribe(res => {
    if (res.success){
      this.resourceCenter = res.data;

    }
  });
  this.getGlossaryData(1);
}

onKeyDownEvent(): void {
    this.getGlossaryData(1, this.searchedValue);
}

resourcePageHeading(sectionId = 9): void {
  this.service.getPageDetails(sectionId).subscribe(res => {
    if (res.success){
      const headings = res.data ?? [];
      this.pageHeading = headings.length ? headings[0] : null;

    }
  });
}

setPage(event: any): void {
  this.page = event.pageIndex + 1;
  this.skip = (event.pageIndex + 1) * this.limit - this.limit;
  this.limit = event.pageSize;
  this.getGlossaryData(event.pageIndex + 1, '', this.orderSorting, this.selectedColumn);
}

  // CLEAR SEARCH
  clearSearch(): void {
    this.searchedValue = '';
    this.onKeyDownEvent();
  }
  redirectUrl(item: any): void {
    this.router.navigate(['/resources-view'], {
      queryParams: { id: item?.id, name: item?.name },
    });

  }

  stripHtmlTags(input: any, limit: number): string {
    const doc: any = new DOMParser().parseFromString(input, 'text/html');

    // Extract plain text content without HTML tags
    const textContent = doc.body.textContent || '';

    // Truncate text content to a limit of 150 characters
    let truncatedText = '';
    if (limit > 0){
      truncatedText  = textContent.length > limit ? textContent.substring(0, limit) + '...' : textContent;
    }
    else{
      truncatedText = textContent;
    }

    return truncatedText;
  }
  sortTable(columnName: any, sortType: string = ''): void {
    this.sortSelection = sortType;
    this.selectedColumn = columnName;
    this.orderSorting = sortType === 'down' ? 'DESC' : 'ASC';
    this.getGlossaryData(this.page, '', this.orderSorting, columnName);
  }

  isShowMore(): boolean {
    return this.resourceCenter.filter((data: any) => data?.types === 'resource').length > 4 ? true : false;
  }

}
